import Image from 'next/image';
import parse from 'html-react-parser';
import styles from './download-story.module.scss';
import { wallexState } from '../../wallex.state';

const DownloadStory = () => {
  const { downloadStory: { title, list, imageUrl, iconUrl } } = wallexState;

  return (
    <div className={styles.container}>
      <section className={styles.section}>
        <div className={styles.section__image}>
          <Image src={imageUrl} alt={title} layout={'fill'} objectFit={'contain'}/>
        </div>
        <div className={styles.section__content}>
          <h2 className={styles.section__title}>{parse(title)}</h2>
          <ul className={styles.section__list}>
            {list.map((item: string, idx: number) => (
              <li key={idx} className={styles.section__list_item}>
                <Image layout={'fixed'} width={24} height={24} objectFit={'contain'} src={iconUrl} alt={'Checkmark'}/>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  )
}

export default DownloadStory;
